import React from 'react';
import { ReactSVG } from 'react-svg';
import { useTranslation } from 'react-i18next';

const HousingSteps = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: 1,
      text: t('js.components.coming_soon_page.step_1'),
    },
    {
      number: 2,
      text: t('js.components.coming_soon_page.step_2'),
    },
    {
      number: 3,
      text: t('js.components.coming_soon_page.step_3'),
    },
    {
      number: 4,
      text: t('js.components.coming_soon_page.step_4'),
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center gap-6 px-4 py-7 lg:flex-row">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <div className="flex flex-col items-center text-center">
            <ReactSVG
              src={require(`@assets/icons/coming-soon-house/number-${step.number}.svg`)}
              beforeInjection={(svg) => {
                svg.setAttribute('width', '40');
                svg.setAttribute('height', '40');
              }}
            />

            <ReactSVG
              src={require(`@assets/icons/coming-soon-house/step-${step.number}.svg`)}
              beforeInjection={(svg) => {
                svg.setAttribute('width', '64');
                svg.setAttribute('height', '64');
              }}
            />
            <div className="text-lead2 font-bold">{step.text}</div>
          </div>

          {index < steps.length - 1 && (
            <>
              <div className="h-0.5 mx-2 hidden w-10 border-t border-dashed border-gray-400 lg:block" />

              <div className="w-0.5 my-2 block h-10 border-l border-dashed border-gray-400 lg:hidden" />
            </>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default HousingSteps;
